import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface InformationAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const InformationAccordion: React.FC<InformationAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();

  // Use actual data from striive job schema
  const striive_job = jobData.striive_job;
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : 'N/A';

  const mappedData = {
    account: striive_job
      ? getValue(striive_job.staffing_supplier_record_id)
      : 'N/A',
    clientProgram: striive_job ? getValue(striive_job.department) : 'N/A',
    clientContact: striive_job
      ? getValue(striive_job.order_contact_full_name)
      : 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title="INFORMATION" expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem('Account:', mappedData.account)}
        {renderDetailItem('Client Program:', mappedData.clientProgram)}
        {renderDetailItem('Client Contact:', mappedData.clientContact)}
      </Grid>
    </JobAccordion>
  );
};
